import { z } from "zod";

// --- Pickup Point Models ---

export const PickupPointSchema = z.object({
  id: z.string(),
  name: z.string(),
  address: z.object({
    full_address: z.string(),
    base_address: z.string().optional(),
    neighborhood: z.string().optional(),
    reference: z.string().optional(),
    city: z.object({
      name: z.string(),
      code: z.string(),
    }),
    province: z.object({
      name: z.string(),
      code: z.string(),
    }),
    country: z.string().length(2), // ISO Alpha-2
  }),
  carrier: z.object({
    id: z.string(), // provider_id e.g. "interrapidisimo"
    name: z.string(),
    logo_url: z.string().url().optional(),
  }),
  is_active: z.boolean(),
  metadata: z.record(z.string(), z.unknown()).optional(),
});

export const PickupPointsResponseSchema = z.object({
  pickup_points: z.array(PickupPointSchema),
});

// --- API Request Schemas ---

export const GetPickupPointsQuerySchema = z.object({
  city_code: z.string().min(1),
  provider_id: z.string().optional(),
});

export type PickupPoint = z.infer<typeof PickupPointSchema>;
export type PickupPointsResponse = z.infer<typeof PickupPointsResponseSchema>;
export type GetPickupPointsQuery = z.infer<typeof GetPickupPointsQuerySchema>;
